interface Feature {
  key: string
  title: string
  description: string
  role: string
}

export const features: Feature[] = [
    {
      key: 'dashboard',
      title: 'profile.features.dashboard.title',
      description: 'profile.features.dashboard.description',
      role: 'dashboard'
    },
    {
      key: 'supervision',
      title: 'profile.features.supervision.title',
      description: 'profile.features.supervision.description',
      role: 'supervision'
    },
    {
      key: 'wan',
      title: 'profile.features.wan.title',
      description: 'profile.features.wan.description',
      role: 'wan'
    },
    {
      key: 'chromecast',
      title: 'profile.features.chromecast.title',
      description: 'profile.features.chromecast.description',
      role: 'stream_cast'
    },
    {
      key: 'wifi_private',
      title: 'profile.features.wifi_private.title',
      description: 'profile.features.wifi_private.description',
      role: 'ran'
    },
    {
      key: 'codes',
      title: 'profile.features.codes.title',
      description: 'profile.features.codes.description',
      role: 'codes'
    },
    {
      key: 'planet_campus',
      title: 'profile.features.planet_campus.title',
      description: 'profile.features.planet_campus.description',
      role: 'planet_campus'
    },
    {
      key: 'announcements',
      title: 'profile.features.announcements.title',
      description: 'profile.features.announcements.description',
      role: 'portal_advertisemente'
    },
    {
      key: 'documents',
      title: 'profile.features.documents.title',
      description: 'profile.features.documents.description',
      role: 'wifirst_documents'
    },
    {
      key: 'audit_report',
      title: 'profile.features.audit_report.title',
      description: 'profile.features.audit_report.description',
      role: 'documents_audin_audit'
    },
    {
      key: 'executed_work',
      title: 'profile.features.executed_work.title',
      description: 'profile.features.executed_work.description',
      role: 'documents_audin_integration'
    },
    {
      key: 'support_docs',
      title: 'profile.features.support_docs.title',
      description: 'profile.features.support_docs.description',
      role: 'documents_support_documentation'
    },
    {
      key: 'financial_reports',
      title: 'profile.features.financial_reports.title',
      description: 'profile.features.financial_reports.description',
      role: 'documents_financial_report'
    },
    {
      key: 'indicator_reports',
      title: 'profile.features.indicator_reports.title',
      description: 'profile.features.indicator_reports.description',
      role: 'documents_indicator_report'
    },
    {
      key: 'other_documents',
      title: 'profile.features.other_documents.title',
      description: 'profile.features.other_documents.description',
      role: 'documents_other_documents'
    },
    {
      key: 'idl',
      title: 'profile.features.idl.title',
      description: 'profile.features.idl.description',
      role: 'idl'
    },
    {
      key: 'ilopex',
      title: 'profile.features.ilopex.title',
      description: 'profile.features.ilopex.description',
      role: 'ilopex'
    },
    {
      key: 'silent_mode',
      title: 'profile.features.silent_mode.title',
      description: 'profile.features.silent_mode.description',
      role: 'silent_mode'
    },
    {
      key: 'sav_stime',
      title: 'profile.features.sav_stime.title',
      description: 'profile.features.sav_stime.description',
      role: 'sav_stime'
    },
    {
      key: 'support',
      title: 'profile.features.support.title',
      description: 'profile.features.support.description',
      role: 'requests'
    },
    {
      key: 'stats_ssids',
      title: 'profile.features.stats_ssids.title',
      description: 'profile.features.stats_ssids.description',
      role: 'statistic_ssid'
    },
    {
      key: 'stats_home',
      title: 'profile.features.stats_home.title',
      description: 'profile.features.stats_home.description',
      role: 'statistic_home'
    },
    {
      key: 'stats_codes',
      title: 'profile.features.stats_codes.title',
      description: 'profile.features.stats_codes.description',
      role: 'statistic_coupons'
    },
    {
      key: 'stats_purchases',
      title: 'profile.features.stats_purchases.title',
      description: 'profile.features.stats_purchases.description',
      role: 'statistic_purchases'
    },
    {
      key: 'stats_chromecast',
      title: 'profile.features.stats_chromecast.title',
      description: 'profile.features.stats_chromecast.description',
      role: 'statistic_chromecast'
    },
    {
      key: 'stats_users',
      title: 'profile.features.stats_users.title',
      description: 'profile.features.stats_users.description',
      role: 'statistic_customers'
    },
    {
      key: 'api_access',
      title: 'profile.features.api_access.title',
      description: 'profile.features.api_access.description',
      role: 'api'
    },
    {
      key: 'fake_contact',
      title: 'profile.features.fake_contact.title',
      description: 'profile.features.fake_contact.description',
      role: 'admin_fake'
    },
    {
      key: 'center_beta',
      title: 'profile.features.center_beta.title',
      description: 'profile.features.center_beta.description',
      role: 'center_beta'
    },
    {
      key: 'speedtest',
      title: 'profile.features.speedtest.title',
      description: 'profile.features.speedtest.description',
      role: 'speedtest'
    },
    {
      key: 'users_management',
      title: 'profile.features.users_management.title',
      description: 'profile.features.users_management.description',
      role: 'admin'
    },
    {
      key: 'iptv',
      title: 'profile.features.iptv.title',
      description: 'profile.features.iptv.description', 
      role: 'iptv_channels'
    },
    {
      key: 'voip',
      title: 'profile.features.voip.title',
      description: 'profile.features.voip.description',
      role: 'voip'
    }
  ]

